import React from 'react';
import meNow from '../../assets/pictures/currentme.png';
import { Link } from 'react-router-dom';
import ResumeDownload from './ResumeDownload';

export interface AboutProps {}

const About: React.FC<AboutProps> = (props) => {
    return (

        <div className="site-page-content">
            {/* <img src={me} style={styles.topImage} alt="" /> */}
            <h1 style={{ marginLeft: -16 }}>Welcome</h1>
            <h3>I'm Jesma Amit</h3>
            <div className="text-block">
                <div style={{}}>
                    <div
                        style={{
                            flex: 1,
                            textAlign: 'justify',
                            alignSelf: 'center',
                            flexDirection: 'column',
                        }}
                    >
                        <h3>About Me</h3>
                        <br />
                        <p>
                         Hi, I'm <strong>Jesma M. Amit</strong>, an Electronics Engineering graduate from <strong>Mapúa University</strong> with a strong foundation in cybersecurity, networking, and cloud computing. 
                         I hold certifications including <strong>CompTIA Security+</strong>, <strong>Microsoft Azure Fundamentals (AZ-900)</strong>, <strong>Google Cybersecurity Certificate</strong>, 
                         and <strong>Google Cloud Cybersecurity Certificate</strong>, alongside a background in <strong>CCNA Enterprise</strong> and <strong>CCNP Core Networking</strong>. 
                         These reflect both my technical skills and my drive for continuous learning.
                        </p>
                        <br />
                        <p>
                         I’ve gained practical experience as a <strong>Global Network Planning & Engineering</strong> at <strong>PLDT Global Corporation</strong>, where I supported 
                         circuit provisioning, service delivery, and international capacity planning. In the <strong>FiveM</strong>, I served as an <strong>Anti-Cheat Moderator</strong>, 
                         applying threat detection methodologies, forensic tools, and zero-trust workflows to monitor systems, detect suspicious behavior, and maintain secure environments.
                        </p>
                        <br />
                        <p>
                         Beyond technical work, I’ve held leadership roles as <strong>Board Auditor</strong> (Batch 77) and <strong>Treasurer</strong> (Batch 76) for <strong>IECEP-MUSC</strong>, strengthening my 
                         collaboration and organizational skills. I’m particularly passionate about <strong>Blue Team operations, SOC analysis, and incident response</strong> and I’m eager to apply my knowledge, 
                         grow alongside professionals, and contribute to building a safer digital world.
                        </p>
                        <br />
                    </div>
                    <div style={styles.verticalImage}>
                        <img src={meNow} style={styles.image} alt="" />
                        <p>
                            <sub>
                                <b>Figure 1:</b> Jesma Pogi
                            </sub>
                        </p>
                    </div>
                </div>
                <br />
                <ResumeDownload />
                <br />
                <br />
                <p>
                    Thank you for taking the time to check out my portfolio. I
                    really hope you enjoy exploring it as much as I enjoyed
                    building it. If you have any questions or comments, feel
                    free to contact me using{' '}
                    <Link to="/contact">this form</Link> or shoot me an email at{' '}
                    <a href="mailto:jezmmit@gmail.com">
                        jezmmit@gmail.com
                    </a>
                </p>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    contentHeader: {
        marginBottom: 16,
        fontSize: 48,
    },
    image: {
        height: 'auto',
        width: '100%',
    },
    topImage: {
        height: 'auto',
        width: '100%',
        marginBottom: 29,
    },
    verticalImage: {
        alignSelf: 'center',
        // width: '80%',
        marginLeft: 32,
        flex: 0.8,

        alignItems: 'center',
        // marginBottom: 32,
        textAlign: 'center',
        flexDirection: 'column',
    },
};

export default About;
